import { render } from "./ListSubject.vue?vue&type=template&id=6a56653c&scoped=true"
import script from "./ListSubject.vue?vue&type=script&lang=js"
export * from "./ListSubject.vue?vue&type=script&lang=js"

import "./ListSubject.vue?vue&type=style&index=0&id=6a56653c&scoped=true&lang=css"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-student-production/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a56653c"]])

export default __exports__